"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandWebhookConfiguration = void 0;
const typeorm_1 = require("typeorm/browser");
const brand_1 = require("./brand");
const contact_profile_enum_1 = require("./contact-profile-enum");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
let BrandWebhookConfiguration = class BrandWebhookConfiguration {
};
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
    }),
    __metadata("design:type", String)
], BrandWebhookConfiguration.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)(),
    (0, typeorm_1.ManyToOne)(() => brand_1.Brand, (brands) => brands.id),
    __metadata("design:type", brand_1.Brand)
], BrandWebhookConfiguration.prototype, "brand", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'text',
        default: '1.0.0',
    }),
    __metadata("design:type", String)
], BrandWebhookConfiguration.prototype, "version", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], BrandWebhookConfiguration.prototype, "url", void 0);
__decorate([
    (0, typeorm_1.Column)('jsonb', { nullable: true }),
    __metadata("design:type", Object)
], BrandWebhookConfiguration.prototype, "additionalHeaders", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], BrandWebhookConfiguration.prototype, "signatureKey", void 0);
__decorate([
    data_ui_1.DataUi.EnumValues(['mobilize', 'dkv']),
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: true,
    }),
    __metadata("design:type", String)
], BrandWebhookConfiguration.prototype, "transformer", void 0);
__decorate([
    (0, typeorm_1.Column)('jsonb', { nullable: true }),
    __metadata("design:type", Object)
], BrandWebhookConfiguration.prototype, "transformerConfig", void 0);
BrandWebhookConfiguration = __decorate([
    data_ui_1.DataUi.Permissions(contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER),
    data_ui_1.DataUi.Name({
        name: 'Brand Webhook Configuration',
        nameProperties: ['id'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Entity)('brand_webhook_configuration', { schema: 'public' })
], BrandWebhookConfiguration);
exports.BrandWebhookConfiguration = BrandWebhookConfiguration;
//# sourceMappingURL=brand-webhook-configuration.js.map